import i18n from '@/../hileadzz_i18n'

const messages = _.merge({}, ...i18n)
const datetime = i18n.Datetime

export { messages, datetime }



// WEBPACK FOOTER //
// ./src/locales.js